<template>
	<div class="sf-input-group-wrapper">
		<!--Ctype-->
		<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001238') }}</span>
		<div class="search-option-wrapper__normal">
			<el-select v-model="data" @change="change">
				<!--전체-->
				<el-option :label="getMessage_('MWCC000753')" value=""></el-option>
				<el-option :key="index" v-for="(item, index) in rptpStList" :label="item.commCdName" :value="item.commCd"></el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RoApcn/store/helpers';
export default {
	data() {
		return {
			data: null
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		change(value) {
			this.setSearchParam_({ key: 'rptpStCd', value: value }).then(() => {
				this.$emit('reload', 1, 10);
			});
		},
		processInfo() {
			this.data = this.searchParams.rptpStCd;
		}
	},
	created() {
		//console.log('조회 값은>>>>>>>>>>>>>>>>>>>>', this.roDdList);

		if (this.searchParams.rptpStCd == null || this.searchParams.rptpStCd == '') this.searchParams.rptpStCd = '';
		this.data = this.searchParams.rptpStCd;
	}
};
</script>

<style></style>
